import { Inject, Injectable } from '@angular/core';
import { NavigationBehaviorOptions, NavigationExtras, Router, UrlTree } from '@angular/router';
import { AUTOMATIONS_ROUTE_PREFIX$ } from '@galaxy/automata/shared';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

// AutomationsRouterService is a service to allow this lib to navigate relative to where this lib is installed in each
// center.

//TODO: use this everywhere so the routing works in busienss APP

@Injectable({ providedIn: 'root' })
export class AutomationsRouterService {
  constructor(
    private router: Router,
    @Inject(AUTOMATIONS_ROUTE_PREFIX$) public readonly routePrefix$: Observable<string>,
  ) {}

  public navigate(commands: any[], extras?: NavigationExtras): void {
    this.routePrefix$.pipe(take(1)).subscribe((routePrefix) => {
      if (commands.length > 0 && routePrefix) {
        commands.unshift(routePrefix);
      }
      this.router.navigate(commands, extras);
    });
  }

  public navigateByUrl(url: string | UrlTree, extras?: NavigationBehaviorOptions): void {
    this.routePrefix$.pipe(take(1)).subscribe((routePrefix) => {
      if (routePrefix) {
        url = routePrefix + url;
      }
      this.router.navigateByUrl(url, extras);
    });
  }

  public applyRoutePrefix(url: string): Observable<string> {
    return this.routePrefix$.pipe(
      take(1),
      map((routePrefix) => {
        return routePrefix ? routePrefix + url : url;
      }),
    );
  }
}
